<template>
  <div class="paySuccess_warp">
    <myHeader />
    <div class="paySuccess_content">
      <div class="paySuccess_box">
        <h3>支付成功</h3>
        <div class="paySuccess_box_content">
            <p>您已购买成功，工作人员会在2小时内为您激活，如遇问题可联系微信：
         
          hecoos_studio
        </p>
        <button @click="jumpTo('/personalCenter')">个人中心</button>
        </div>
        
      </div>
    </div>
    <myFooter />
  </div>
</template>
<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
export default {
  data() {
    return {
    }
  },
  methods: {
    jumpTo(url){
      this.$router.push(url)
    }
  },
  components: {
    myHeader,
    myFooter
  },
}
</script>
<style lang="scss" scoped>
.paySuccess_warp {
  .paySuccess_content {
    width: 100%;
    height: calc(100vh - 152px);
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;

    .paySuccess_box {
      width: 600px;
      height: 300px;
      padding: 24px;
      background-color: #fff;
      border-radius: 16px;
      font-size: 22px;
      text-align: center;
      .paySuccess_box_content{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 230px;
      }
      h3 {
        font-size: 24px;
      }

      p {
        text-align: left;
        margin: 16px 0;

      }

      button {
        border: none;
        background-color: #3c99eb;
        color: #fff;
        padding: 8px 20px;
        margin-top: 20px;
        border-radius: 8px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>